// app/translate/translate.pipe.ts

import { Pipe, PipeTransform , Component, ElementRef} from '@angular/core';
import { DomSanitizer} from '@angular/platform-browser'
import { TranslateServiceForm } from './../translate'; 
import { MessageUtil } from './'; 

@Pipe({name: 'convertStatus'})
export class LogConvertStatusPipe implements PipeTransform {
    private messageUtil:MessageUtil;
    constructor(private _translate: TranslateServiceForm, private sanitizer: DomSanitizer ) { 
        this.messageUtil = new MessageUtil(_translate);
    }
    transform(rowData: any, type: any[]): any {
        return this.sanitizer.bypassSecurityTrustHtml(this.messageUtil.convertStatus(rowData, type));
    }

    public static new(rowData: any) {
        console.log(rowData);
    }
}



// WEBPACK FOOTER //
// C:/Users/sung/WebstormProjects/exafe front/src/app/utility/util.pipe.ts